@use "../../styles/breakpoint.module.scss" as *;

.root {
    visibility: visible;
}

.match {
    composes: root;
    composes: match from "../../styles/theming.module.css";
}

.contrast {
    composes: root;
    composes: contrast from "../../styles/theming.module.css";
}

.grid {
    composes: gridContainer from "../../styles/composable/layout.module.css";
}

.header {
    grid-column: span 8;
    margin-bottom: var(--spacer-40);

    @media ($below-mobile) {
        grid-column: 1 / -1;
    }
}

.item {
    grid-column: span 4;

    @media ($below-mobile) {
        &:not(:last-child) {
            grid-column: span 2;
        }
    }
}

.media {
    display: block;
    position: relative;
    width: 100%;
    height: auto;
    aspect-ratio: 4 / 3;
    overflow: hidden;

    & :is(img, video) {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        object-fit: cover;
    }
}

.richText {
    margin-top: var(--spacer-16);

    & :is(p, li) {
        font: var(--font-p-16);
    }
}
